export const UpgradeRequestSent: FcDiv = ({ children }) => {
  return (
    <p className="h-[1.375rem] font-semibold text-[0.875rem] leading-[1.375rem] text-center text-[#FF9500]">
      {children}
    </p>
  );
};
